function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.209 5.495a2.747 2.747 0 110-5.495 2.747 2.747 0 010 5.495zm8.791 0A2.747 2.747 0 1112 0a2.747 2.747 0 010 5.495zm8.791 0a2.747 2.747 0 110-5.495 2.747 2.747 0 010 5.495z",
  fill: "#4A4C4C",
  fillRule: "evenodd"
});

function SvgIcMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 6
  }, props), _ref);
}

export default SvgIcMore;